module.exports = __webpack_public_path__ + "f90262e9eb14de62c91f967420197805.woff";


//////////////////
// WEBPACK FOOTER
// ./src/uikit/assets/font/noto-sans-kr-v11-korean_latin-500.woff
// module id = 459
// module chunks = 0